import { StyleSheet } from 'react-native'
import { Metrics } from 'APP/Themes'

export default StyleSheet.create({
  container: {
    marginHorizontal: Metrics.baseMargin,
    marginBottom: Metrics.baseMargin,
  },
})
